// @flow
import React, { type Node, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';

import {
  Api,
  createApiData,
  // standartRequests,
  // type OccurType,
  // type ErrorByIdType,
  type RequestFuncType,
  // type StandartRequestFuncType,
} from 'app/common/context/Api';


export const History = createApiData();

const makeRequestsData = (id, from, to, t, schoolId) => ((id && from && to && t) ? {
  data: {
    path: 'cafeteria/customer/finances',
    type: 'get',
    rest: {
      params: {
        customer_id: id,
        from_date: from,
        to_date: to,
        school_id: schoolId,
        for_camp: !!schoolId,
      },
    },
    cbErrorTextCreate: (/* error */) => (
      `${t('request_finances_history_failed')} ${moment(from).format('D MMMM YYYY')}${
        from === to
          ? ''
          : ` — ${moment(to).format('D MMMM YYYY')}`
      }`
    ),
    autoRequest: true,
  },
} : {});

type ItemDetail = {
  datetime: string,
  type: 'subtract' | 'add',
  title: string,
  sum: number,
  bill_pdf_url?: string,
}

export type DayDetails = {
  subtracted: number,
  added: number,
  at_start?: number,
  at_end?: number,
  details: Array<ItemDetail>,
}

export type HistoryItem = {
  subtracted: number,
  added: number,
  at_start?: number,
  at_end?: number,
  details: {
    [string]: DayDetails
  }
}

export type State = {
  content: {
    data: {
      [string]: HistoryItem,
    }
  },
  loading: boolean,
  request: {
    data: RequestFuncType,
  },
  error?: { [string]: mixed },
}

type Props = {
  personId: number,
  from: string,
  to: string,
  children: Node | (value: State) => Node,
  schoolId?: number,
}

const initialContent = {
  data: {},
};

const HistoryApi = ({ children, personId, from, to, schoolId }: Props) => {
  const { t } = useTranslation('finances');

  const descriptions = useMemo(
    () => makeRequestsData(personId, from, to, t, schoolId),
    [personId, from, to, t, schoolId],
  );

  return (
    <Api
      // consoleLogName="HistoryApi"
      apiData={History}
      descriptions={descriptions}
      initialContent={initialContent}
    >
      {children}
    </Api>
  );
};

export default HistoryApi;
